<template>
  <div id="goodslists">
    <div class="tableheader">
      <el-button @click="editGoods(-1)" class="btn1" type="primary" size="small">{{$t("goods_add")}}</el-button>
      <el-button v-show="false" @click="dialogGoodsVisible=true" class="btn1" type="primary" size="small">{{$t("goods_import")}}</el-button>
      <el-button @click="deleteGoods" class="btn1" type="primary" size="small">{{$t("delete_select")}}</el-button>
      <el-button @click="getList('search')" class="btn3" type="primary" size="small">{{$t("search")}}</el-button>
      <el-input class="codeshearch" size="small" v-model="sForm.q" :placeholder="$i18n.t('goods_keyword')" ></el-input>
    </div>
    <div class="deviceAddBlock">
      <el-table :data="lists" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="ID" width="100"></el-table-column>
        <el-table-column  :label="$i18n.t('goods_img')" width="150">
          <template slot-scope="scope">
            <img :src="scope.row.goods_pic.indexOf('http')==-1?('/fileSvr/get/'+scope.row.goods_pic):scope.row.goods_pic" width="80" height="80" />
          </template>
        </el-table-column>
        <el-table-column prop="goods_name" :label="$i18n.t('goods_name')">
          <template slot-scope="scope">
            <div class="goods_name">
              {{scope.row.goods_name}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="price" :label="$i18n.t('price')" width="100" v-if="goodsMode!='solrx'"></el-table-column>
        <el-table-column prop="tag" :label="$i18n.t('goods.goods_tags')" width="100" v-if="goodsMode=='solrx'"></el-table-column>
        <el-table-column :label="$i18n.t('workfor')" width="200" v-if="goodsMode!='solrx'">
          <template slot-scope="scope">
            <span class="warncolor">{{scope.row.goods_type_attr.type_str}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$i18n.t('contral')">
          <template slot-scope="scope">
            <el-button @click="editGoods(scope.row)" class="btn1" type="primary" size="mini">{{$t("edit")}}</el-button>
            <el-button @click="delGoods(scope.row.id)" class="btn1" type="primary" size="mini">{{$t("delete")}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination v-show="showFlow"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="sForm.page"
        :page-sizes="[20, 50, 100, 200, 500]"
        :page-size="sForm.pageSize"
        layout="sizes,total, prev, pager, next"
        :total="sForm.total"
        style="margin-top: 0.0833rem"
      >
      </el-pagination>
    </div>
    <el-dialog :title="$i18n.t('delete_status')" :visible.sync="dialogVisible" width="30%">
      <span>{{$t("delete_tips")}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{$t("normal_cancle")}}</el-button>
        <el-button type="primary" @click="sureDelGoods">{{$t("normal_sure")}}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$i18n.t('goods_import')" :visible.sync="dialogGoodsVisible" width="600">
      <span class="lh18">{{$t("nice_tips")}}</span><br />
      <span class="lh18">{{$t("goods_import_tips")[0]}}</span><br />
      <span class="lh18">{{$t("goods_import_tips")[1]}}</span><br />
      <span class="lh18">{{$t("goods_import_tips")[2]}}</span><br />
      <span class="lh18">{{$t("goods_import_tips")[3]}}</span>
      <div class="modelxls">
        <img src="../assets/img/xls.png" /><br />
        <span class="lh18">{{$t("goods_import_demo")}}</span><br />
        <a target="_blank" href="https://api.yimei.ai/fileSvr/get/prd-mj3/20200523/8c8af4ddfaad5ade25f7583d3a0f079d-2251799854208683.zip" type="primary" size="small">下载模板</a>
      </div>
      <div class="uploadbutton">
        <el-upload ref="upload" :data="sForm" class="upload-demo" action="/skinmgr/goods/importGoods" multiple :limit="1" :on-success="importantOk">
          <el-button size="small" type="primary">{{$t("buchong").upload}}</el-button>
        </el-upload>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'goodslists',
  data () {
    return {
      showFlow: false,
      showadddefault: false,
      showdelfault: false,
      doing: false,
      doingc: false,
      doingl: false,
      sForm:{
        q: '',
        page: 1,
        pageSize: 20,
        total: 100
      },
      lists: null,
      dialogVisible: false,
      ids: [],
      dialogGoodsVisible: false,
      goodsMode: null
    }
  },
  computed: {

  },
  created () {
    if (localStorage.goodlistParam) {
      this.sForm = JSON.parse(localStorage.goodlistParam)
    }
    this.getList();
    this.initConf();
  },
  methods: {
    initConf() {
        let _this = this
        if(localStorage.userConfs){
            let confs = JSON.parse(localStorage.userConfs)
            if(confs.goods_mode){
                _this.goodsMode = confs.goods_mode
            }
        }
      },
    importantOk (response, file, fileList) {
      if (response.code === 0){
        this.$message(this.$i18n.t('goods_import_tips')[4])
        this.getList()
        this.dialogGoodsVisible = false
      } else {
        if (response.msg) {
          this.$message(response.msg)
        } else {
          this.$message(this.$i18n.t('goods_import_tips')[5])
        }
      }
      this.$refs.upload.clearFiles();
    },
    handleSelectionChange(val) {
      this.ids = []
      if (val) {
        for(let i in val) {
          if(val[i].goods_id) {
            this.ids.push(val[i].id)
          }
        }
      }
      console.log(this.ids)
    },
    handleSizeChange (val) {
      this.sForm.page = 1
      this.sForm.pageSize = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.sForm.page = val
      this.getList()
    },
    getList (ty) {
      //if (this.doingl === true) {
      //  return false
      //}
      let dataLoadIng = this.openFullScreen()
      //this.doingl = true
      let _this = this
      let data = this.sForm
      if (ty === 'search') {
        data.page = 1
      }
      this.axios.post('/skinMgrSrv/goods/list', this.formData(data)).then(function (response) {
        //_this.doingl = false
        if (response.data.code === 0) {
          _this.lists = null
          setTimeout(function () {
            _this.lists = response.data.list
            _this.sForm.total = response.data.total
            _this.showFlow = true
            _this.showadddefault = false
            _this.showdelfault = false
            if (response.data.hasdefault === 1) {
              _this.showdelfault = true
            }else{
              _this.showadddefault = true
            }
          }, 300)
        }
        setTimeout(() => {
          dataLoadIng.close()
        }, 600);
        console.log(response.data)
      }).catch(function (res) {
          setTimeout(() => {
              dataLoadIng.close()
          }, 600);
      })
    },
    delGoods (goods_id) {
      this.ids = []
      this.ids.push(goods_id)
      this.dialogVisible = true
    },
    deleteGoods () {
      if (this.ids.length < 1) {
        this.$message(this.$i18n.t('select_to_delete'))
        return false
      }
      this.dialogVisible = true
    },
    sureDelGoods () {
      if (this.ids.length < 1) {
        this.$message(this.$i18n.t('select_must'))
        return false
      }
      if (this.doing === true) {
        return false
      }
      this.doing = true
      let _this = this
      let data = {
        'goods_id': this.ids
      }
      this.axios.post('/skinMgrSrv/goods/del', this.formData(data)).then(function (response) {
        _this.doing = false
        _this.dialogVisible = false
        if (response.data.code === 0) {
          _this.$message(_this.$i18n.t('deletesuccess'))
          _this.getList()
        }
      }).catch(function (res) {
          _this.doing = false
      })
    },
    editGoods (goods) {
      localStorage.goodlistParam = JSON.stringify(this.sForm);
      localStorage.edit_goods = JSON.stringify(goods)
      localStorage.activeMenu = this.$i18n.t('goods_edit')
      this.$router.push({ path: '/skinmgr/goodsEdit'})
    }
  }
}
</script>
<style  lang="scss">
  #goodslists{
    .tabs-container {
      .el-card__header {
        padding: 0.0833rem 0.1667rem !important;
      }
      .el-card{
        cursor: pointer;
      }
      .el-card:hover{
        border: $blue 1px solid;
      }
    }
    .el-dialog__header{
      border-bottom: #E9E9E9 1px solid !important;
    }
    .el-button--primary {
      color: #fff;
      background-color: #57AEC9;
      border-color: #57AEC9;
    }
    .el-radio-button__orig-radio:checked+.el-radio-button__inner {
      color: #fff;
      background-color: #57AEC9;
      border-color: #57AEC9;
      -webkit-box-shadow: -1px 0 0 0 #57AEC9;
      box-shadow: -1px 0 0 0 #57AEC9;
    }
    .dialog-footer-center{
      text-align: center;
    }
  }

</style>

<style scoped lang="scss">
  #goodslists {
    margin: 0.16rem;
    padding: 0.16rem;
    background-color: #fff;
    border-radius: 0.04rem;
    box-sizing: border-box;
    .tableheader{
      margin-top: 0.0833rem;
    }
    p.title{
      height: 0.4167rem;
      line-height:0.4167rem;
      font-size:0.15rem;
      color:#000;
    }
    .btn2,.btn3{
      padding: 0.0667rem 0.0833rem;
    }
    .codeshearch{
      width: 1.667rem;
    }
    .btn3,.codeshearch{
      float: right;
      margin-right: 0.0833rem;
    }
    .codeshearch{
      width: 1.25rem;
    }
    .deviceAddBlock{
      margin-top: 0.0833rem;
    }
    .goods_name{
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .lh18{
      margin-bottom: 0.1rem;
      line-height: 180%;
    }
    .modelxls{
      position:absolute;
      border: 1px solid #ccc;
      top: 0.7rem;
      right: 0.2rem;
      width: 0.9rem;
      height: 1.2rem;
      text-align: center;
      padding-top: 0.1rem;
      a{
        margin-top: 0.1rem;
        border: 1px solid #ccc;
        height: 0.25rem;
        line-height: 0.25rem;
        border-radius: 0.15rem;
        width: 0.7rem;
        display: block;
        margin-left: 0.1rem;
      }
    }
    .uploadbutton{
      width: 100%;
      height: auto;
      margin-top: 0.5rem;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/goods/list.vue